import styled from "styled-components";

export const Footer1=styled.div` 
color: white;
`;

export const Footerup=styled.div` 
height: 383px;
background-color:rgb(84,86,88) ;

`;


export const FooterLower=styled.div` 
height:96px;
display: flex;
background-color:rgb(47,51,55) ;

`;

export const Flex=styled.div` 
display: flex;

`;

export const Grid=styled.div` 
flex: 1;
margin: 5%;
`;


export const Head=styled.p` 
margin-bottom: 5%;
`;

export const Para=styled.p` 
margin-bottom: 12%;
`;

export const Lower1=styled.p` 
margin:2%;
`;

export const Lower2=styled.p` 
margin :1% 1% 0% 35%;
`;